import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#saeulen", label: "Säulen" },
  { href: "#ueber-mich", label: "Über mich" },
  { href: "#begleitung", label: "Begleitung" },
  { href: "#pay-per-use", label: "Pay-per-Use" },
  { href: "#foerdermittel", label: "Fördermittel" },
  { href: "#kontakt", label: "Kontakt" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-xl border-b border-black/10"
          : "bg-white/70 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="font-display font-black tracking-tighter text-xl md:text-2xl flex items-center gap-2"
        >
          <span className="inline-block w-2 h-2 bg-[#D30000]" />
          MHorgas<span className="text-[#D30000]">Consult</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-sm font-medium hover-marker tracking-tight"
            >
              {l.label}
            </a>
          ))}
          <a href="#kontakt" data-testid="header-cta" className="btn-primary text-sm">
            Erstgespräch
          </a>
        </nav>

        <button
          onClick={() => setOpen((o) => !o)}
          className="md:hidden p-2"
          aria-label="Menü öffnen"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/10 bg-white">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.href.replace("#", "")}`}
                className="text-base font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              className="btn-primary text-sm self-start"
              data-testid="mobile-header-cta"
            >
              Erstgespräch
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
